import { combineReducers } from 'redux';
import { connectRouter, RouterAction, LocationChangeAction, RouterState } from 'connected-react-router';
import { reducer as toastrReducer, ToastrState } from 'react-redux-toastr';
import { History } from 'history';

import app, { IAppState, AppAction } from './app';
import user, { IUserState, UserAction } from './user';

export interface IRootState {
  app: IAppState;
  user: IUserState;
  router: RouterState;
  toastr: ToastrState;
}

export type IRootAction =
  | AppAction
  | UserAction
  | RouterAction
  | LocationChangeAction;

export default (history: History) => combineReducers({
  app,
  user,
  router: connectRouter(history),
  toastr: toastrReducer,
});
